import api from "@/lib/api";

// iter372 pt 1 — marqueurs « ouvert » par utilisateur : compteurs latéraux = non lus.
export const SEEN_EVENT = "desk:seen";

export async function markSeen(module, id) {
  if (!module || !id) return;
  const at = new Date().toISOString();
  window.dispatchEvent(new CustomEvent(SEEN_EVENT, { detail: { module, id, at } }));
  try {
    const { data } = await api.post(`/seen/${module}/${id}`);
    if (data?.seen_at) window.dispatchEvent(new CustomEvent(SEEN_EVENT, { detail: { module, id, at: data.seen_at } }));
  } catch { /* silent */ }
}

// Non lu = jamais ouvert, ou modifié (activityAt) après la dernière ouverture.
export function isUnread(seenMap, id, activityAt) {
  const seen = seenMap?.[id];
  if (!seen) return true;
  if (!activityAt) return false;
  return new Date(activityAt).getTime() > new Date(seen).getTime();
}
